import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './hero-banner-item-col.component.scss';
import { MediaQueryService } from '../../services/media-query.service';
var HeroBannerItemCol = /** @class */ (function (_super) {
    tslib_1.__extends(HeroBannerItemCol, _super);
    function HeroBannerItemCol(element) {
        var _this = _super.call(this, element) || this;
        _this.w = 1200;
        _this.h = 480; // initial height of the image
        _this.ratio = _this.w / _this.h;
        return _this;
    }
    HeroBannerItemCol.prototype.init = function () {
        this.imageHolder = this.element.querySelector('.hero-banner-item-col__image-holder');
        this.desktopImages = Array.from(this.element.querySelectorAll('.hero-banner-item-col__col-image__desktop'));
        this.tabletImages = Array.from(this.element.querySelectorAll('.hero-banner-item-col__col-image__tablet'));
        this.mobileImages = Array.from(this.element.querySelectorAll('.hero-banner-item-col__col-image__mobile'));
        this.contentBackground = this.element.querySelector('.hero-banner-item-col__content-background');
        setTimeout(this.onResize.bind(this));
    };
    HeroBannerItemCol.prototype.bindEvents = function () {
        window.addEventListener('resize', this.onResize.bind(this));
    };
    HeroBannerItemCol.prototype.onResize = function () {
        if (MediaQueryService.getMediaQuery() === 'small' || MediaQueryService.getMediaQuery() === 'x-small') {
            this.desktopImages.map(function (item) {
                item.classList.remove('hero-banner-item-col__col-image__show');
                item.classList.add('hero-banner-item-col__col-image__hidden');
            });
            this.tabletImages.map(function (item) {
                item.classList.remove('hero-banner-item-col__col-image__show');
                item.classList.add('hero-banner-item-col__col-image__hidden');
            });
            this.mobileImages.map(function (item) {
                item.classList.remove('hero-banner-item-col__col-image__hidden');
                item.classList.add('hero-banner-item-col__col-image__show');
            });
        }
        else if (MediaQueryService.getMediaQuery() === 'medium-small' || MediaQueryService.getMediaQuery() === 'medium' || MediaQueryService.getMediaQuery() === 'large') {
            this.desktopImages.map(function (item) {
                item.classList.remove('hero-banner-item-col__col-image__show');
                item.classList.add('hero-banner-item-col__col-image__hidden');
            });
            this.tabletImages.map(function (item) {
                item.classList.remove('hero-banner-item-col__col-image__hidden');
                item.classList.add('hero-banner-item-col__col-image__show');
            });
            this.mobileImages.map(function (item) {
                item.classList.remove('hero-banner-item-col__col-image__show');
                item.classList.add('hero-banner-item-col__col-image__hidden');
            });
        }
        else {
            this.desktopImages.map(function (item) {
                item.classList.remove('hero-banner-item-col__col-image__hidden');
                item.classList.add('hero-banner-item-col__col-image__show');
            });
            this.tabletImages.map(function (item) {
                item.classList.remove('hero-banner-item-col__col-image__show');
                item.classList.add('hero-banner-item-col__col-image__hidden');
            });
            this.mobileImages.map(function (item) {
                item.classList.remove('hero-banner-item-col__col-image__show');
                item.classList.add('hero-banner-item-col__col-image__hidden');
            });
        }
        var ww = window.innerWidth;
        var el = this.element;
        el.style.opacity = '1';
        if (ww > this.w) {
            var bannerHeight = ww / this.ratio;
            var colWidth = this.w / 12;
            var cbWidth = ((ww - (12 * colWidth)) / 2) + (4 * colWidth);
            // this.imageHolder.style.height = bannerHeight + 'px';
            // this.contentBackground.style.width = cbWidth + 'px';
            // this.contentBackground.style.height = bannerHeight + 'px';
        }
        else {
            this.contentBackground.style.removeProperty('height');
            if (MediaQueryService.getMediaQuery() === 'x-small') {
                this.contentBackground.style.width = '100%';
                this.imageHolder.style.height = '122px';
            }
            else if (MediaQueryService.getMediaQuery() === 'small') {
                this.contentBackground.style.width = '100%';
                this.imageHolder.style.height = '250px';
            }
            else if (MediaQueryService.getMediaQuery() === 'medium') {
                this.imageHolder.style.removeProperty('height');
                var colWidth = ww / 12;
                this.contentBackground.style.width = (5 * colWidth) + 'px';
            }
            else {
                this.imageHolder.style.removeProperty('height');
                var colWidth = ww / 12;
                this.contentBackground.style.width = (4 * colWidth) + 'px';
            }
        }
    };
    return HeroBannerItemCol;
}(Base));
export { HeroBannerItemCol };



//////////////////
// WEBPACK FOOTER
// ./components/hero-banner-item-col/hero-banner-item-col.component.ts
// module id = 355
// module chunks = 0